import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { RemindersSendPayload } from 'Interfaces/Document';
import { $actions } from 'Store';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: RemindersSendPayload) =>
    $actions.documentSign.sendReminders(dispatch, payload),
  );
};
